/**
 * Clubs
 */
var ClubCollection = /** @class */ (function () {
    function ClubCollection() {
        this.resultsCount = 0;
        this.from = 0;
        this.to = 0;
        this.clubs = [];
    }
    return ClubCollection;
}());
export { ClubCollection };
var ClubType = /** @class */ (function () {
    function ClubType() {
        this.clubTypeId = 0;
        this.index = 0;
        this.clubType = "";
        this.longName = "";
    }
    return ClubType;
}());
export { ClubType };
var Club = /** @class */ (function () {
    function Club() {
        this.clubId = 0;
        this.playerId = 0;
        this.clubTypeId = 0;
        this.clubType = "";
        this.clubName = "";
        this.longName = "";
        this.averageMeters = 0;
        this.averageYards = 0;
        this.longMeters = 0;
        this.longYards = 0;
        this.shortMeters = 0;
        this.shortYards = 0;
        this.isActive = true;
        this.inserted = "";
        this.updated = "";
        this.shotCount = 0;
    }
    return Club;
}());
export { Club };
/**
 * Handicap
 */
var HandicapEntryCollection = /** @class */ (function () {
    function HandicapEntryCollection() {
        this.resultsCount = 0;
        this.from = 0;
        this.to = 0;
        this.handicapEntries = [];
    }
    return HandicapEntryCollection;
}());
export { HandicapEntryCollection };
var Handicap = /** @class */ (function () {
    function Handicap() {
        this.handicapEntryId = 0;
        this.playerId = 0;
        this.roundId = 0;
        this.courseId = 0;
        this.secondaryCourseId = 0;
        this.teeTypeId = 0;
        this.teeType = "";
        this.teeColorType = "";
        this.holesPlayed = 0;
        this.adjustedGrossScore = 0;
        this.courseRating = 0;
        this.courseSlope = 0;
        this.handicapEligible = true;
        this.usedInHandicap = true;
        this.frontNinePlayed = true;
        this.backNinePlayed = true;
        this.courseName = "";
        this.inserted = "";
        this.updated = "";
    }
    return Handicap;
}());
export { Handicap };
/**
 * Players
 */
var Player = /** @class */ (function () {
    function Player() {
        this.playerId = 0;
        this.statusId = 0;
        this.status = "";
        this.measurementTypeId = 0;
        this.measurementType = "";
        this.securityTypeId = 0;
        this.securityType = "";
        this.firstName = "";
        this.lastName = "";
        this.email = "";
        this.culture = "";
        this.recentRound = "";
        this.handicap = 0;
        this.isMale = true;
        this.isRightHanded = true;
        this.deviceToken = "";
        this.pushTypes = "";
        this.wasPremium = false;
        this.isMonthly = false;
        this.isYearly = false;
        this.inserted = "";
        this.updated = "";
        this.roles = [];
        this.clubs = [];
        this.friends = [];
        this.modules = [];
        this.medias = [];
        this.handicapEntries = new HandicapEntryCollection();
        this.recentRounds = [];
        this.bestRounds = "";
        this.extendedStatThisPlayerThisMonth = "";
        this.extendedStatThisPlayerThisYear = "";
        this.extendedStatThisAreaThisMonth = "";
        this.extendedStatThisAreaThisYear = "";
        this.extendedStatGlobalThisMonth = "";
        this.extendedStatGlobalThisYear = "";
        this.homeCourse = "";
    }
    return Player;
}());
export { Player };
/**
 * PlayerExtendedStats
 */
var PlayerExtendedStatsCollection = /** @class */ (function () {
    function PlayerExtendedStatsCollection() {
        this.resultsCount = 0;
        this.from = 0;
        this.to = 0;
        this.playerExtendedStats = [];
    }
    return PlayerExtendedStatsCollection;
}());
export { PlayerExtendedStatsCollection };
var PlayerExtendedStats = /** @class */ (function () {
    function PlayerExtendedStats() {
        this.players = [];
        this.startDate = "";
        this.endDate = "";
        this.scorecardCount = 0;
        this.holeCount = 0;
        this.par3Count = 0;
        this.par4Count = 0;
        this.par5Count = 0;
        this.averagePar = 0;
        this.averageGrossScore = 0;
        this.averageHandicap = 0;
        this.averagePar3GrossScore = 0;
        this.averagePar4GrossScore = 0;
        this.averagePar5GrossScore = 0;
        this.averageFrontNineGrossScore = 0;
        this.averageBackNineGrossScore = 0;
        this.averageStablefordScore = 0;
        this.averageFrontNineStablefordScore = 0;
        this.averageBackNineStablefordScore = 0;
        this.averageNetScore = 0;
        this.averageAdjustedGrossScore = 0;
        this.averagePuttTotal = 0;
        this.averageFrontNinePuttTotal = 0;
        this.averageBackNinePuttTotal = 0;
        this.averagePenaltyStrokeTotal = 0;
        this.averageFrontNinePenaltyStrokeTotal = 0;
        this.averageBackNinePenaltyStrokeTotal = 0;
        this.averageHolesAbovePar = 0;
        this.averageStrokesAbovePar = 0;
        this.averageTotalDrives = 0;
        this.averageStraightDrives = 0;
        this.averageLeftDrives = 0;
        this.averageRightDrives = 0;
        this.averageTopDrives = 0;
        this.averageChunkDrives = 0;
        this.averageGIR = 0;
        this.averagePar3GIR = 0;
        this.averagePar4GIR = 0;
        this.averagePar5GIR = 0;
        this.averagePuttsPerHole = 0;
        this.averagePuttsPerGIR = 0;
        this.averageScrambleChances = 0;
        this.averageScrambleSuccesses = 0;
        this.averageSandSaveChances = 0;
        this.averageSandSaveSuccesses = 0;
        this.averagePenaltyStrokes = 0;
        this.averageEagles = 0;
        this.averageBirdies = 0;
        this.averagePars = 0;
        this.averageBogeys = 0;
        this.averageDoubleBogeys = 0;
        this.averageOverDoubleBogeys = 0;
        this.holesAboveParPercentage = 0;
        this.strokesAboveParPercentage = 0;
        this.straightDrivePercentage = 0;
        this.leftDrivePercentage = 0;
        this.rightDrivePercentage = 0;
        this.topDrivePercentage = 0;
        this.chunkDrivePercentage = 0;
        this.girPercentage = 0;
        this.par3GIRPercentage = 0;
        this.par4GIRPercentage = 0;
        this.par5GIRPercentage = 0;
        this.scrambleSuccessPercentage = 0;
        this.sandSaveSuccessPercentage = 0;
        this.eaglePercentage = 0;
        this.birdiePercentage = 0;
        this.parPercentage = 0;
        this.bogeyPercentage = 0;
        this.doubleBogeyPercentage = 0;
        this.overDoubleBogeyPercentage = 0;
        this.fullRoundStrokesAbovePar = 0;
        this.fullRoundGrossScore = 0;
        this.fullRoundPar = 0;
        this.sumEagles = 0;
        this.sumBirdies = 0;
        this.sumPars = 0;
        this.sumBogeys = 0;
        this.sumDoubleBogeys = 0;
        this.sumOverDoubleBogeys = 0;
        this.rounds = [];
    }
    return PlayerExtendedStats;
}());
export { PlayerExtendedStats };
/**
 * Generic
 */
var HttpResponseMessage = /** @class */ (function () {
    function HttpResponseMessage() {
        this.messageText = "";
        this.reason = "";
    }
    return HttpResponseMessage;
}());
export { HttpResponseMessage };
/**
 * Miscellaneous
 */
// playerextendedstats.playerextendedstats[i].player
var Players = /** @class */ (function () {
    function Players() {
        this.playerId = 0;
        this.month = 0;
        this.year = 0;
        this.playerName = "";
    }
    return Players;
}());
export { Players };
var Role = /** @class */ (function () {
    function Role() {
        this.roleId = 0;
        this.playerId = 0;
        this.name = "";
        this.description = "";
        this.origin = "";
        this.expires = "";
        this.inserted = "";
        this.coupons = "";
    }
    return Role;
}());
export { Role };
var Friend = /** @class */ (function () {
    function Friend() {
        this.playerId = 0;
        this.unauthorizedPlayerId = 0;
        this.statusId = 0;
        this.status = "";
        this.nickName = "";
        this.email = "";
        this.handicap = 0;
        this.inserted = "";
        this.updated = "";
    }
    return Friend;
}());
export { Friend };
var Module = /** @class */ (function () {
    function Module() {
        this.moduleId = 0;
        this.playerId = 0;
        this.name = "";
    }
    return Module;
}());
export { Module };
// Rounds
var RoundCollection = /** @class */ (function () {
    function RoundCollection() {
        this.resultsCount = 0;
        this.from = 0;
        this.to = 0;
        this.rounds = [];
    }
    return RoundCollection;
}());
export { RoundCollection };
var Round = /** @class */ (function () {
    function Round() {
        this.roundId = 0;
        this.courseId = 0;
        this.courseSecondaryId = 0;
        this.course = "";
        this.isFinished = true;
        this.inserted = "";
        this.updated = "";
        this.score = 0;
        this.teeType = "";
        this.teeColorType = "";
    }
    return Round;
}());
export { Round };
// Types
var DriveResultType = /** @class */ (function () {
    function DriveResultType() {
        this.driveResultTypeId = "";
        this.name = "";
    }
    return DriveResultType;
}());
export { DriveResultType };
var Hole = /** @class */ (function () {
    function Hole() {
        this.scorecardId = 0;
        this.holeNum = 0;
        this.score = 0;
        this.putts = 0;
        this.driveResultType = "";
        this.penaltyStrokes = 0;
        this.bunkerHit = false;
    }
    return Hole;
}());
export { Hole };
